const checkValidSepaInput = (value): boolean => {
  const regEx = new RegExp(/[^A-Za-z0-9/?:!@#$&().,'+-\s]+/g)
  return !regEx.test(value)
}
module.exports = checkValidSepaInput
